// Module
var code = "<react-component name=\"ManageWebsiteGallery\" props=\"{save: save, websiteData: website, websiteUrl: websiteUrl()}\"></react-component>\n";
// Exports
module.exports = code;